import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react';
import buildQueryParams from '../../utils/buildQueryParams';
import { useSelector } from 'react-redux';
import { fetchMessageAnalytics } from '../../api/message';

let userMetricsData = [
  {
    title: 'Total Messages Sent',
    totalMessages: 0,
    messagesSentDaily: 0,
    percentage: 0,
    image: '/assets/images/admin-panel/messages.svg',
  },
  {
    title: 'Total Replied',
    totalMessages: 0,
    percentage: 0,
    image: '/assets/images/admin-panel/messages.svg',
  },
];

const MessagingMetrics = () => {
  // Static data for different periods
  const [metricsData, setMetricsData] = useState([]);
  // const { filter } = useSelector((state) => state);
  const filter = useSelector((state) => state.filter);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);

  useEffect(() => {
    fetchMessageAnalytics(filter, setMetricsData, userMetricsData);
  }, [JSON.stringify(filterWithoutUTM)]);

  return (
    <div className="border p-20 rounded-4">
      <div className="d-flex justify-content-between align-items-center gap-12">
        <h6 className="text-neutral-900">Messaging Metrics</h6>
      </div>
      <div className="totalValue font-24 fw-medium text-neutral-900">
        {userMetricsData[0].totalMessages}
      </div>
      <div className="d-flex justify-content-between align-items-center gap-4 mt-16">
        <div className="d-flex gap-3 w-100">
          {metricsData.map((metric, index) => (
            <div key={index} className="border p-20 rounded-4 w-100">
              <div className="">
                <div className="d-flex gap-2 align-items-center font-14">
                  <img
                    src={metric.image}
                    className="img-fluid"
                    alt={`${metric.title} Icon`}
                  />
                  {metric.title}
                </div>
                <div className="font-20 fw-medium text-neutral-900 mt-8">
                  {metric.messagesSentDaily}
                </div>
                <div className="font-12 fw-medium text-neutral-500">
                  <span
                    className={`${
                      metric.percentage >= 0
                        ? 'text-success-800'
                        : 'text-danger-800'
                    }`}
                  >
                    {metric.percentage >= 0
                      ? `${metric.percentage}%`
                      : `${metric.percentage}%`}
                  </span>{' '}
                  Last Month
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="progress w-100 h-100 h-117px">
          <div
            className="progress-bar bg-success-600"
            role="progressbar"
            style={{ width: `${userMetricsData[1].totalMessages}` }}
            aria-valuenow={userMetricsData[1].totalMessages}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            {userMetricsData[1].totalMessages}
            <span className="d-block">Replied</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessagingMetrics;
